import React, { useState, useEffect } from "react";
import { Info } from "lucide-react";
import { useNavigate } from "react-router-dom";

const TrialExpirationBanner = ({ user }) => {
    const navigate = useNavigate();
    const [remainingDays, setRemainingDays] = useState(null);

    useEffect(() => {
        if (user?.tokenExpiration) {
            const now = new Date();
            const exp = new Date(user.tokenExpiration);
            const diffTime = exp - now;
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            setRemainingDays(diffDays);
        }
    }, [user?.tokenExpiration]);

    if (remainingDays === null) return null;

    const isExpired = remainingDays <= 0;

    const getTheme = () => {
        if (isExpired) return { container: "bg-red-50 border-red-200", iconBg: "bg-red-100", iconText: "text-red-600", linkHover: "hover:text-red-700" };
        return { container: "bg-[#FFF8EB] border-[#FFE7C1]", iconBg: "bg-[#FFF3D6]", iconText: "text-[#EF8702]", linkHover: "hover:text-[#EF8702]" };
    };

    const theme = getTheme();

    return (
        <div className={`p-4 rounded-2xl border flex items-start gap-4 shadow-sm animate-in fade-in slide-in-from-top-4 duration-500 ${theme.container}`}>
            <div className={`p-2 rounded-full flex-shrink-0 ${theme.iconBg}`}>
                <Info className={`w-5 h-5 ${theme.iconText}`} />
            </div>
            <p className="text-[#1D2129] text-sm md:text-base font-medium leading-relaxed self-center">
                {isExpired ? (
                    <>
                        Your free trial tokens have expired.{" "}
                        <button
                            onClick={() => navigate('/user-dashboard/upgrade-plan')}
                            className={`font-bold underline text-[#1D2129] ${theme.linkHover} transition-colors`}
                        >
                            Upgrade
                        </button>{" "}
                        to continue translating.
                    </>
                ) : (
                    <>
                        You’re using free trial tokens. Kindly{" "}
                        <button
                            onClick={() => navigate('/user-dashboard/upgrade-plan')}
                            className={`font-bold underline text-[#1D2129] ${theme.linkHover} transition-colors`}
                        >
                            Upgrade
                        </button>{" "}
                        in {remainingDays} {remainingDays === 1 ? 'day' : 'days'} to extend your token validity and keep your translations uninterrupted.
                    </>
                )}
            </p>
        </div>
    );
};

export default TrialExpirationBanner;
